import Images from './Images'

const seoConfig = {
  title: 't(seoSST.title)',
  subtitle: 't(seoSST.subtitle)',
  description: 't(seoSST.description)',
  image: Images.SEO.Image,
  social: {
    facebook: 'https://www.facebook.com/supersittersapp/',
    instagram: 'https://www.instagram.com/supersitters.app',
  },
}

export default seoConfig
